import React from 'react';
import Elevate2024  from 'views/Elevate2024';
const ExtraCurricularActivitiesPage = () => {
  return <Elevate2024 />;
};

export default ExtraCurricularActivitiesPage;